export { WindDisplay } from "./WindDisplay";
export type { WindDisplayProps } from "./WindDisplay";
